"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const React = __importStar(require("react"));
const SvgCampaignViewed = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, fill: "none" }, props),
    React.createElement("path", { fill: "#D9EAF5", d: "M30.533 21.238a.98.98 0 0 1 0 1.192c-1.012 1.333-3.79 4.4-7.797 4.4s-6.787-3.08-7.797-4.4a.975.975 0 0 1 0-1.192c1.012-1.334 3.79-4.4 7.797-4.4s6.792 3.074 7.797 4.4" }),
    React.createElement("path", { fill: "#58627D", fillRule: "evenodd", d: "M15.742 21.833c.99 1.292 3.504 3.997 6.994 3.997 3.493 0 6.007-2.699 6.994-3.996-.98-1.29-3.5-3.997-6.994-3.997s-6.007 2.699-6.994 3.996m-1.598-1.203c1.044-1.374 4.083-4.792 8.592-4.792s7.556 3.428 8.593 4.793a1.98 1.98 0 0 1 0 2.405c-1.043 1.373-4.082 4.793-8.593 4.793-4.513 0-7.555-3.437-8.592-4.792l.795-.607-.792.61a1.976 1.976 0 0 1-.003-2.41", clipRule: "evenodd" }),
    React.createElement("path", { fill: "#fff", d: "M24.74 21.83a2 2 0 1 1-4 0 2 2 0 0 1 4 0" }),
    React.createElement("path", { fill: "#58627D", fillRule: "evenodd", d: "M22.74 20.83a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-3 1a3 3 0 1 1 6 0 3 3 0 0 1-6 0", clipRule: "evenodd" }),
    React.createElement("path", { fill: "#58627D", fillRule: "evenodd", d: "M3 2a1 1 0 0 0-1 1v20a1 1 0 0 0 1 1h2a1 1 0 0 1 1 1v4l4.364-3.276a1 1 0 0 1 1.2 1.6L5.6 31.8A1 1 0 0 1 4 31v-5H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3h26a3 3 0 0 1 3 3v10a1 1 0 1 1-2 0V3a1 1 0 0 0-1-1z", clipRule: "evenodd" }),
    React.createElement("path", { fill: "#58627D", fillRule: "evenodd", d: "M6 9.015a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1M6 14.015a1 1 0 0 1 1-1h3a1 1 0 0 1 0 2H7a1 1 0 0 1-1-1M6 19.015a1 1 0 0 1 1-1h3a1 1 0 0 1 0 2H7a1 1 0 0 1-1-1", clipRule: "evenodd" })));
exports.default = SvgCampaignViewed;
